export default __webpack_public_path__ + "static/media/ic-dashboard.748b5a14.svg";